import { render, staticRenderFns } from "./gw.vue?vue&type=template&id=57345a3a&scoped=true"
import script from "./gw.vue?vue&type=script&lang=js"
export * from "./gw.vue?vue&type=script&lang=js"
import style0 from "./gw.vue?vue&type=style&index=0&id=57345a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57345a3a",
  null
  
)

export default component.exports